import { defHttp } from '/@/utils/http/axios';
import {
  TransactionParams,
  TransactionListGetResultModel,
  CancelOrderParams,
} from './model/transaction';
import {
  AccountSchemeType,
  AreaType,
  CashFlowResultType,
  DealPriceType,
  GetProductDetailParams,
  GetProductEventResultType,
  GetProductShareResultType,
  IndustryType,
  ProductDetailType,
  SearchProductResultModel,
  SearchDroResultModel,
  SearchDroParams,
  DroOrderSearchParams,
  DroOrderResultModel,
  DroOrderExcelResultModel,
  DroOrderSubmitParams,
  DroOrderSubmitResultModel,
  batchCancelResultModel,
  DroBatchOrderParams,
  DroBatchOrderResultModel,
  FileItem,
  ExtendInfoItem,
} from './model/product';
import {
  LoginAccountSearchParams,
  LoginAccountSearchResultModel,
} from '/@/api/exchangeService/model/loginAccount';
import {
  SettlementBankSearchResultModel,
  TradingAccountSearchParams,
  TradingAccountSearchResultModel,
  fundTransferRequestModel,
  AddSettlementBankRequestModel,
  TradingAccountAllResultModel,
  AccountResultModel,
  AccountRequestModel,
} from '/@/api/exchangeService/model/tradingAccount';
import {
  HoldingDistributionResultModel,
  HoldingListGetResultModel,
  HoldingParams,
  HoldingRequestParams,
  HoldingRequestType,
  HoldingResultType,
  HoldingRevenueItem,
  HoldingStatisticResultModel,
  IncomeDistributionDetailParams,
  IncomeDistributionDetailResultModel,
  IncomeDistributionItem,
  IncomeDistributionParams,
  IncomeDistributionResultModel,
  PositionChangeDetailRequestType,
  PositionChangeDetailResultType,
  IBusiness,
  ExportRecordParams,
  ExportRecordResultModel,
} from '/@/api/exchangeService/model/holding';
import {
  ProductDistributionReqsItem,
  ProductGroupRevenueItem,
  ProductGroupShareReqsItem,
  ProductMarketInfo,
  SubmitAoOrderParams,
  SubmitSoOrderParams,
  TradeFeeParams,
  TransactionTimeType,
  TransferDistributionResultModel,
  FindProBaseInfo,
  GetAvailableShares,
} from '/@/api/exchangeService/model/trade';
import { SummaryGetResultModel } from './model/home';
import { addCollectRequestModel, addCollectResultModel } from './model/optional';
import {
  ExportFundFlowParams,
  FundFlowsRequestType,
  FundFlowsResultType,
  FundTypeItem,
  fundFlowsRequestModel,
  fundFlowsResultModel,
  rechargeRequestModel,
  withdrawRequestModel,
} from './model/finance';
import { ContentTypeEnum } from '/@/enums/httpEnum';
import { AreaTypeEnum, SettlementTypeEnum } from '/@/enums/exchangeServiceEnum';
import { MenuItem } from '../sys/model/menuModel';
import {
  EtpBaseInfo,
  EtpDetailType,
  EtpSummaryParams,
  EtpSummaryType,
  GetHistoryTransactionParams,
  MarketType,
  QueryLoopInvestParams,
  QueryLoopInvestRes,
  ReferListType,
  SearchEtpResultModel,
} from './model/productEtp';
import { MonthlyStatementRequestType, MonthlyStatementResultType } from './model/settle';
import {
  CreateRoleItem,
  ProfessionalInvestorItem,
  ProfessionalInvestorParams,
  ProfessionalInvestorResultModel,
  ProfessionalInvestorSubmitItem,
  ProfessionalInvestorSubmitResult,
  ProfessionalTypeTextParams,
  RoleInfoItem,
  RoleInfoParams,
  RoleListResultModel,
} from './model/member';
import { DRORecordResultModel } from '/@/api/market/model/market';
import {
  EntrustTransactionListGetResultModel,
  ExportIoOrderParams,
  ExportSoOrderParams,
} from './model/entrust';
enum Api {
  Transaction_LIST = '/table/getDemoList',
  ProductMarket = '/ex/trade/match-order/product/market',
  DroDetailInfo = '/ex/product/product/detail-info',
  DroEventList = '/ex/product/product/event-list',
  DroShareInfo = '/ex/product/product/share-info',
  Login_Account_Search_LIST = '/member/login-accounts/search',
  tradingAccountSearch = '/member/trading-accounts/search',
  tradingAccountAll = '/member/trading-accounts/find-all',
  cashBalance = '/member/trading-accounts/cash-balance',
  IncomeRatio = '/analysis/consumptionIndex/queryIncomeRatio',
  AssetIrr = '/analysis/consumptionIndex/queryAssetIrr',
  // 查询持仓详情
  HoldingSearch = '/member/certificate-books/search',
  // 查询持仓组合分布（饼图）
  HoldingDistribution = '/ex/member/certificate-books/distribution',
  // 查询持仓现金流表现（折线图）
  HoldingRevenue = '/ex/member/member/member-profit',
  // 查询持仓概要
  HoldingStatistic = '/member/certificate-books/overview',
  IncomeDistribution = '/ex/member/settle-product-divided',
  IncomeDistributionList = '/ex/member/settle-product-divided/search',
  // PRD收益分配
  PRDIncomeDistributionList = '/member/fund/divided-list',
  IncomeDistributionDetail = '/ex/member/settle-product-divided/detail/search',
  TransferDistribution = '/ex/product/product/distribution',
  TransferRevenue = '/ex/product/product/group-share',
  ProductSearch = '/ex/product/product/search',
  SoOrderSubmit = '/trade/match-order/submit',
  AoOrderSubmit = '/trade/direct-order/submit',
  geoDistribution = '/analysis/consumptionIndex/geoDistribution',
  queryLastDate = '/analysis/consumptionIndex/queryLastDate',
  querySummaryIndex = '/analysis/consumptionIndex/querySummaryIndex',
  querySoSummaryIndex = '/analysis/consumptionIndex/querySoSummaryIndex',
  industryDistribution = '/analysis/consumptionIndex/industryDistribution',
  news = '/analysis/news',
  addCollect = '/analysis/productcollect/add-collect',
  // 取消自选
  cancelCollect = '/analysis/productcollect/cancel-collect',
  fundFlows = '/member/fund/flow-list',
  // 充值
  recharge = '/member/trading-accounts/recharge',
  // 提现
  withdraw = '/member/trading-accounts/withdraw',
  // so订单查询
  soOrderSearch = '/trade/match-order/list',
  // ao订单查询
  aoOrderSearch = '/trade/direct-order/list',
  // 取消so订单
  soOrderCancel = '/trade/match-order/cancel',
  // 取消ao订单
  aoOrderCancel = '/trade/direct-order/cancel',
  // 划拨资金
  transfer = '/member/trading-accounts/fund-transfer',
  // 创建子交易账号
  createSubAccount = '/member/trading-accounts/sub',
  // 资金划拨记录查询
  fundTransferSearch = '/member/trading-accounts/fund-transfer/records',
  // 查询会员结算行账号信息
  querySettlementAccount = '/ex-member/settlement-bank-account-info',
  // 新增结算行账号信息
  addSettlementAccount = '/ex-member/settlement-bank-account-info',
  // 修改结算行账号信息
  updateSettlementAccount = '/ex-member/settlement-bank-account-info/update',
  // 注销结算行账号
  cancelSettlementAccount = '/ex-member/settlement-bank-account-info/cancel',
  // 行业品类业态
  industryCategory = '/analysis/product/get-industry',
  // 地区查询
  areaSearch = '/analysis/product/get-area',
  // 分账方案查询
  divisionChannel = '/ex/product/product/get-division-channel',
  // 分账主导方查询
  divisionScheme = '/ex/product/product/get-division-scheme',
  // 获取角色列表
  roleList = '/member/login-accounts/sub/formal-roles',
  // 获取角色对应菜单
  roleMenu = '/member/menus',
  // 批量查询成交价
  batchPrice = '/ex/trade/kchart/latest',
  // 上传结算凭证
  uploadVoucher = '/ex-member/settlement-bank-account-info/files',

  // etp列表
  etpList = '/analysis/product/etp/search',
  // etp详情
  etpDetail = '/analysis/product/etp/detail-info',
  // etp每日现金流
  etpCashFlow = '/analysis/product/etp/acf-info',
  // etp行情
  etpMarket = '/analysis/product/etp/market',
  // etp 历史行情
  etpHistoryMarket = '/analysis/product/etp/market-his',
  // 市场参考收益率
  etpReferList = '/analysis/product/etp/refer-list',
  // etp基本信息
  etpBaseInfo = '/analysis/product/etp/base-info',

  /**
   * [etp汇总](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E4%BA%A7%E5%93%81%E8%A1%A8/summary)
   */
  etpSummary = '/analysis/product/etp/summary',

  // 历史交易记录
  etpHistoryTransaction = '/analysis/product/trade-his',
  // 今日行情
  etpTodayMarket = '/analysis/product/match-his',

  // 查询对某个产品的持仓
  accountProductHold = '/member/certificate-books/find-one',

  // 查询交易时间
  queryTradeTime = '/trade/direct-order/trade-day',

  // 仓位变动明细
  positionChangeDetail = '/member/certificate-books/flow-list',

  // 是否存在申购条款
  isExistPurchaseClause = '/trade/subscription-terms/existence',

  // 下载申购条款
  downloadPurchaseClause = '/trade/subscription-terms/download',

  // 资金操作流水
  fundFlowsList = '/member/fund/recharge-withdraw-list',

  // 月结单
  monthlyStatement = '/member/trading-accounts/settlement-report',

  // 下载月结单
  downloadMonthlyStatement = '/member/trading-accounts/settlement-report/download',

  // 查询角色
  roleSearch = '/member/roles/search',

  // 查询角色详情
  roleDetail = '/member/roles',
  // 获取会员可用菜单
  memberMenu = '/member/menus/available',

  // 创建角色
  createRole = '/member/roles/create',
  // 更新角色
  updateRole = '/member/roles/update',
  // 删除角色
  deleteRole = '/member/roles/delete',

  // 资产明细列表
  assetDetailList = '/analysis/maap/etp-asset-search',

  // 获取费率
  rateSearch = '/trade/fee-rate',
  // dro交易列表
  searchDroList = '/analysis/product/dro/search',

  // 查询产品基本信息
  findProBaseInfo = '/analysis/product/find-product-baseinfo',

  // DRO产品交易规则
  getDroTradeRule = '/analysis/productextendinfo/dro-extend-info-list',

  // 委托订单列表 DRO IO
  droOrderSearch = '/trade/direct-order/list',
  // 批量下单模板
  excelOrderTemplateApi = '/trade/dro-order/io/batch-order-template',
  // 分页查询excel上传的订单
  droOrderSearchExcel = '/trade/dro-order/io/batch-order-list',
  // 提交订单
  droOrderSubmit = '/trade/dro-order/new-io-order',

  // 获取可申购份额
  getAvailableShares = '/trade/dro-order/io/getAvailable-shares',

  // 费率描述文件
  rateDescription = '/trade/fee-rate/mcex-services-and-fees',

  // 批量撤单
  batchCancel = '/trade/direct-order/cancel-batch',
  // 是否开启循环投资
  queryLoopInvest = '/trade/loop-invest/query',

  // 开启循环投资
  loopInvestOpen = '/trade/loop-invest/open',
  // 关闭循环投资
  loopInvestClose = '/trade/loop-invest/close',

  // 获取应投金额总和
  investBalanceSum = '/trade/loop-invest/balance-sum',
  // dro列表导出
  droListExport = '/analysis/product/dro/search-export',
  // 现金流导出
  cashFlowExport = '/analysis/product/dro/cash-flow-export',
  // 批量下单校验文件导出
  batchOrderCheckExport = '/trade/dro-order/io/batch-order-list-export',
  // 持仓列表导出
  holdingExport = '/member/certificate-books/search-export',
  // dro 收益记录导出
  droRecordExport = '/member/fund/flow-list-export',

  // **专业投资人**
  // 查询专业投资人列表
  professionalList = '/member/pi/search',
  // 查询专业投资人详情
  professionalDetail = '/member/pi',
  // 提交专业投资人
  professionalSubmit = '/member/pi/submit',
  // 获取pi类型声明文本
  professionalTypeText = '/member/statement',
  // 查询数据导出生成中的数量统计
  exportCount = '/member/export-record/count-generating',
  // 导出记录表
  exportRecordApi = '/member/export-record/list',
  // dro批量下单
  droBatchOrder = '/trade/dro-order/manual-upload-order',

  // 查询产品文件
  productFileList = '/analysis/product/file-list',
  // 查询产品扩展信息
  productExtendInfo = '/analysis/productextendinfo/extend-info-list',
  // 资金流水导出
  fundFlowsExport = '/member/fund/fund-flow-export',
  // 委托SO订单导出
  soOrderExport = '/trade/match-order/list-export',
  // 委托AO/IO订单导出
  ioOrderExport = '/trade/direct-order/list-export',
  // 资金类型字典
  fundTypeDict = '/member/fund/get-fund-type-dict',
  // 币种数量查询
  currencyCount = '/analysis/product/dro/check-currency',
}
// 批量下单上传
export const excelOrderApi = '/trade/dro-order/io/batch-order-upload';

/**
 * @description: Get sample list value
 */

export const transactionListApi = (params: TransactionParams) =>
  defHttp.get<TransactionListGetResultModel>({
    url: Api.Transaction_LIST,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

/**
 * 产品搜索
 * @param {object} params 产品查询请求入参
 * @param {number} params.pageNo 页码，从 1 开始
 * @param {number} params.pageSize 每页条数，最大值为 100
 * @param {number} params.droType dro类型，1 AO，2 IO，3 SO
 * @param {string} params.memberCode 查询自选，需要传memberCode
 * @param {string} params.productCode 产品编码
 * @param {number} params.releaseAmountStart 发行金额 start
 * @param {number} params.releaseAmountEnd 发行金额 end
 * @param {number} params.totalSharesStart 发行份额 start
 * @param {number} params.totalSharesEnd 发行份额 end
 * @param {string} params.planBeginDateStart 合约起始日 start
 * @param {string} params.planBeginDateEnd 合约起始日 end
 * @param {string} params.planExitDateStart 合约结束日 start
 * @param {string} params.planExitDateEnd 合约结束日 end
 * @param {number} params.planDateLengthStart 合约长度-天 start
 * @param {number} params.planDateLengthEnd 合约长度-天 end
 * @param {array} params.categoryCodeList 品类编码
 * @param {array} params.sectorCodeList 业态编码
 * @param {array} params.industryCodeList 行业编码
 * @param {array} params.districtCode 区县编码
 * @param {array} params.cityCode 城市编码
 * @param {array} params.provinceCode 省份编码
 * @param {number} params.operatingDaysStart 门店运营天数 start
 * @param {number} params.operatingDaysEnd 门店运营天数 end
 * @param {number} params.leftLeaseDaysStart 剩余租约长度
 * @param {number} params.leftLeaseDaysEnd 剩余租约长度
 * @param {string} params.leaseEndDateStart 门店租约结束日期 start
 * @param {string} params.leaseEndDateEnd 门店租约结束日期 end
 * @param {number} params.shopPattern 开店模式:1直营,2加盟
 * @param {array} params.divisionScheme 分账主导方
 * @returns
 */
export const searchProductApi = (params: TransactionParams) =>
  defHttp.post<SearchProductResultModel>({
    url: Api.ProductSearch,
    params,
  });

export const loginAccountSearchApi = (params: LoginAccountSearchParams) =>
  defHttp.post<LoginAccountSearchResultModel>({
    url: Api.Login_Account_Search_LIST,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

/**
 * 获取交易账号列表
 * @param params
 * @returns
 */
export const tradingAccountSearchApi = (params: TradingAccountSearchParams) =>
  defHttp.post<TradingAccountSearchResultModel>({
    url: Api.tradingAccountSearch,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });
/**
 * [获取交易账号列表（不含资金余额）](https://mtex-dev2.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E4%BA%A4%E6%98%93%E8%B4%A6%E6%88%B7/fundAll)
 * @param params
 * @returns
 */
export const tradingAccountAllApi = (params: TradingAccountSearchParams) =>
  defHttp.post<TradingAccountAllResultModel>({
    url: Api.tradingAccountAll,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });
/**
 * [查询账号资金余额](https://mtex-dev2.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E4%BA%A4%E6%98%93%E8%B4%A6%E6%88%B7/fundAll)
 * @param params
 * @returns
 */
export const fetchCashBalanceApi = (params: AccountRequestModel) =>
  defHttp.get<AccountResultModel>({
    url: Api.cashBalance,
    params,
    headers: {
      // @ts-ignore
      ignoreCancelToken: true,
    },
  });

/**
 * 产品报价表
 * @param {object} params 入参
 * @param {string} params.pdCode 产品编码
 * @returns
 */
export const fetchProductMarket = (params: { pdCode: string }) =>
  defHttp.get<ProductMarketInfo>({
    url: Api.ProductMarket,
    params,
  });

/**
 * 产品详情
 * @param {object} params 入参
 * @param {string} params.productCode 产品编码
 * @returns
 */
export const droDetailInfoApi = (params: GetProductDetailParams) =>
  defHttp.get<ProductDetailType>({
    url: Api.DroDetailInfo,
    params,
  });

/**
 * 产品公告
 * @param {object} params 入参
 * @param {string} params.productCode 产品编码
 * @returns
 */
export const droEventListApi = (params: GetProductDetailParams) =>
  defHttp.get<GetProductEventResultType>({
    url: Api.DroEventList,
    params,
  });

/**
 * 产品现金流表现图
 * @param {object} params 入参
 * @param {string} params.productCode 产品编码
 * @returns
 */
export const droShareInfoApi = (params: GetProductDetailParams) =>
  defHttp.get<GetProductShareResultType>({
    url: Api.DroShareInfo,
    params,
  });

/**
 * [持仓查询](https://exmt-dev1-api.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E6%89%98%E7%AE%A1%E7%99%BB%E8%AE%B0%E5%86%8C%E6%8C%81%E4%BB%93%E6%98%8E%E7%BB%86/searchMemberHoldingDetails)
 * @param {object} params 持仓查询入参
 * @param {string} params.certificateAccountCode 登记托管账号代码
 * @returns
 */
export const holdingSearchApi = (params: HoldingParams) => {
  return defHttp.post<HoldingListGetResultModel>({
    url: Api.HoldingSearch,
    params,
  });
};
// 持仓导出
export const ExportHoldingApi = (params: HoldingParams) => {
  return defHttp.post(
    {
      url: Api.holdingExport,
      params,
    },
    {
      isTransformResponse: false,
    },
  );
};

/**
 * 持仓组合分布图
 * @param {object} params 持仓组合分布图入参
 * @param {string} params.certificateAccountCode 登记托管账号代码
 * @returns
 */
export const getHoldingDistribution = (params: HoldingRequestParams) => {
  return defHttp.post<HoldingDistributionResultModel>({
    url: Api.HoldingDistribution,
    params,
  });
};

/**
 * 持仓组合收益折线图
 * @param {object} params 持仓组合收益折线图入参
 * @param {string} params.certificateAccountCode 登记托管账号代码
 * @returns
 */
export const getHoldingRevenue = (params: HoldingRequestParams) => {
  return defHttp.post<HoldingRevenueItem[]>({
    url: Api.HoldingRevenue,
    params,
  });
};

/**
 * [持仓概要统计]()
 * @param {object} params 持仓概要统计入参
 * @param {string} params.certificateAccountCode 登记托管账号代码
 * @returns
 */
export const getHoldingStatistic = (params: HoldingRequestParams) => {
  return defHttp.post<HoldingStatisticResultModel>({
    url: Api.HoldingStatistic,
    params,
  });
};

export const getIncomeDistributionList = (params: IncomeDistributionParams) => {
  return defHttp.post<IncomeDistributionResultModel>({
    url: Api.IncomeDistributionList,
    params,
  });
};

/**
 * [收益分配](https://mtex-dev2.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E8%B5%84%E9%87%91%E8%B4%A6%E6%88%B7/dividedList)
 * @param params
 * @returns
 */
export const getPRDIncomeDistributionList = (params: IncomeDistributionParams) => {
  return defHttp.post<IncomeDistributionResultModel>({
    url: Api.PRDIncomeDistributionList,
    params,
  });
};

export const getIncomeDistributionDetail = (params: IncomeDistributionDetailParams) => {
  return defHttp.post<IncomeDistributionDetailResultModel>({
    url: Api.IncomeDistributionDetail,
    params,
  });
};

export const getIncomeDistribution = (params) => {
  return defHttp.get<IncomeDistributionItem>({
    url: Api.IncomeDistribution,
    params,
  });
};

/**
 * 所选产品组合分布图
 * @param {ProductDistributionReqsItem[]} params 所选产品组合分布图入参
 * @returns
 */
export const getTransferDistribution = (params: ProductDistributionReqsItem[]) => {
  return defHttp.post<TransferDistributionResultModel>({
    url: Api.TransferDistribution,
    params,
  });
};

/**
 * 所选产品组合收益折线图
 * @param {object} params 持仓组合收益折线图入参
 * @param {string} params.certificateAccountCode 登记托管账号代码
 * @returns
 */
export const getTransferRevenue = (params: ProductGroupShareReqsItem[]) => {
  return defHttp.post<ProductGroupRevenueItem[]>({
    url: Api.TransferRevenue,
    params,
  });
};

/**
 * 接口 [获取滴灌额指数](https://mtex-dev1.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/exchange-index-controller/querySummaryIndex)
 * @请求头 `Post /analysis/consumptionIndex/queryIncomeRatio`
 */
export const incomeRatioApi = (params) =>
  defHttp.post<TransactionListGetResultModel>({
    url: Api.IncomeRatio,
    params,
  });

export const assetIrrApi = (params) =>
  defHttp.post<TransactionListGetResultModel>({
    url: Api.AssetIrr,
    params,
  });

/**
 * 获取门店地域分布
 * @param params
 * @returns
 */
export const geoDistribution = (params) =>
  defHttp.post<TransactionListGetResultModel>({
    url: Api.geoDistribution,
    params,
  });

/**
 * 获取最新数据日期 供指数大屏查询使用
 * @param params
 * @returns
 */
export const queryLastDate = () =>
  defHttp.get<string>({
    url: Api.queryLastDate,
  });

/**
 * [获取概览](https://mtex-dev1.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/%E6%8C%87%E6%95%B0%E5%A4%A7%E5%B1%8F/querySummaryIndex)
 * @param params
 * @returns
 */
export const querySummaryIndex = (params) =>
  defHttp.post<SummaryGetResultModel>({
    url: Api.querySummaryIndex,
    params,
  });

/**
 * [获取So概览](https://mtex-dev1.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/%E6%8C%87%E6%95%B0%E5%A4%A7%E5%B1%8F/querySoSummaryIndex)
 * @param params
 * @returns
 */
export const querySoSummaryIndex = (params) =>
  defHttp.post<SummaryGetResultModel>({
    url: Api.querySoSummaryIndex,
    params,
  });

/**
 * 获取门店行业分布
 * @param params
 * @returns
 */
export const industryDistribution = (params) =>
  defHttp.post<SummaryGetResultModel>({
    url: Api.industryDistribution,
    params,
  });

/**
 * 获取资讯
 * @param params
 * @returns
 */
export const news = (params) =>
  defHttp.post<SummaryGetResultModel>({
    url: Api.news,
    params,
  });

/**
 * 加入自选
 * @param params
 * @returns
 */
export const addCollect = (params: addCollectRequestModel) =>
  defHttp.post<addCollectResultModel>({
    url: Api.addCollect,
    params,
  });
/**
 * 取消自选
 * @param params
 * @returns
 */
export const cancelCollect = (params: addCollectRequestModel) =>
  defHttp.post<addCollectResultModel>({
    url: Api.cancelCollect,
    params,
  });

/**
 * SO订单批量提交
 * @param params
 * @returns
 */
export const submitSoOrder = (params: SubmitSoOrderParams) =>
  defHttp.post<Boolean>({
    url: Api.SoOrderSubmit,
    params,
  });

/**
 * AO、IO订单批量提交
 * @param params
 * @returns
 */
export const submitAoOrder = (data: SubmitAoOrderParams, params?) =>
  defHttp.post<Boolean>({
    url: Api.AoOrderSubmit,
    params,
    data,
  });

/**
 * [获取资金明细](https://mtex-dev2.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E8%B5%84%E9%87%91%E8%B4%A6%E6%88%B7/flowList)
 * @param params
 * @returns
 */
export const fetchFundFlows = (params: fundFlowsRequestModel) =>
  defHttp.post<fundFlowsResultModel>({
    url: Api.fundFlows,
    params,
  });

/**
 * 充值申请
 * @param params
 * @returns
 */
export const recharge = (params: rechargeRequestModel) =>
  defHttp.post<fundFlowsResultModel>({
    url: Api.recharge,
    params,
  });

/**
 * 提现申请
 * @param params
 * @returns
 */
export const withdraw = (params: withdrawRequestModel) =>
  defHttp.post<fundFlowsResultModel>({
    url: Api.withdraw,
    params,
  });

/**
 * 获取Etp So订单列表
 */
export const fetchEtpSoOrderList = (params: TransactionParams) =>
  defHttp.post<TransactionListGetResultModel>({
    url: Api.soOrderSearch,
    params,
  });
/**
 * 获取So订单列表
 */
export const fetchSoOrderList = (params: TransactionParams) =>
  defHttp.post<TransactionListGetResultModel>({
    url: '/ex' + Api.soOrderSearch,
    params,
  });
/**
 * [获取EtpAo订单列表](https://exmt-dev1-api.microconnect.cc/trade/doc.html#/-trade-v3-api-docs/AO-IO%E7%94%B3%E8%B4%AD%E6%8E%A5%E5%8F%A3/selectPage_5)
 */
export const fetchEtpAoOrderList = (params: TransactionParams) =>
  defHttp.post<EntrustTransactionListGetResultModel>({
    url: Api.aoOrderSearch,
    params,
  });
/**
 * [获取订单列表]()
 */
export const fetchAoOrderList = (params: TransactionParams) =>
  defHttp.post<TransactionListGetResultModel>({
    url: '/ex' + Api.aoOrderSearch,
    params,
  });

/**
 * 取消EtpSo订单
 */
export const cancelEtpSoOrder = (params: CancelOrderParams) =>
  defHttp.post<TransactionListGetResultModel>({
    url: Api.soOrderCancel,
    params,
  });
/**
 * 取消So订单
 */
export const cancelSoOrder = (params: CancelOrderParams) =>
  defHttp.post<TransactionListGetResultModel>({
    url: '/ex' + Api.soOrderCancel,
    params,
  });

/**
 * 取消EtpAo订单
 * @param params
 * @returns
 *  */
export const cancelEtpAoOrder = (params: CancelOrderParams) =>
  defHttp.post<TransactionListGetResultModel>({
    url: Api.aoOrderCancel,
    params,
  });

/**
 * 取消Ao订单
 * @param params
 * @returns
 *  */
export const cancelAoOrder = (params: CancelOrderParams) =>
  defHttp.post<TransactionListGetResultModel>({
    url: '/ex' + Api.aoOrderCancel,
    params,
  });

/**
 * 分配资金
 * @param params
 * @returns
 *  */
export const fundTransfer = (params: fundTransferRequestModel) =>
  defHttp.post<TransactionListGetResultModel>({
    url: Api.transfer,
    params,
  });

/**
 * 创建子交易账号
 * @param params
 * @returns
 *  */
export const createSubAccount = (params: fundTransferRequestModel) =>
  defHttp.post<TransactionListGetResultModel>({
    url: Api.createSubAccount,
    params,
  });

/**
 * 查询资金划拨记录
 * @param params
 * @returns
 *  */
export const fundTransferSearch = (params: fundTransferRequestModel) =>
  defHttp.post<TransactionListGetResultModel>({
    url: Api.fundTransferSearch,
    params,
  });

/**
 * 查询会员结算行账号信息
 * @returns
 */
export const querySettlementAccount = () =>
  defHttp.get<SettlementBankSearchResultModel>({
    url: Api.querySettlementAccount,
  });

/**
 * 新增结算行账号信息
 * @returns
 */
export const addSettlementAccount = (params: AddSettlementBankRequestModel) =>
  defHttp.post<Boolean>({
    url: Api.addSettlementAccount,
    params,
  });
/**
 * 更新结算行账号信息
 * @returns
 */
export const updateSettlementAccount = (params: AddSettlementBankRequestModel) =>
  defHttp.post<Boolean>({
    url: Api.updateSettlementAccount,
    params,
  });

/**
 * [注销结算行账号](https://mtex-dev1.microconnect.cc/ex-member/doc.html#/-ex-member-v3-api-docs/%E7%BB%93%E7%AE%97%E8%A1%8C%E8%B4%A6%E5%8F%B7%E4%BF%A1%E6%81%AF/cancelSettlementBankAccountInfo)
 */
export const cancelSettlementAccount = (params: { bankAccountNo: string }) =>
  defHttp.post<Boolean>({
    url: Api.cancelSettlementAccount,
    params,
  });

/**
 * 接口 [行业品类业态查询](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E4%BA%A7%E5%93%81%E8%A1%A8/getIndustry)
 * @returns
 * */
export const queryIndustryCategory = (params: { parentCode: `${number}` }) =>
  defHttp.get<IndustryType[]>({
    url: Api.industryCategory,
    params,
    headers: {
      'Content-Type': ContentTypeEnum.FORM_URLENCODED,
    },
  });

/**
 * 接口 [地区动态查询](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E4%BA%A7%E5%93%81%E8%A1%A8/getArea)
 * @returns
 * */
export const areaSearch = (params: { parentCode: string; areaType: AreaTypeEnum }) =>
  defHttp.get<AreaType[]>({
    url: Api.areaSearch,
    params,
    headers: {
      'Content-Type': ContentTypeEnum.FORM_URLENCODED,
    },
  });

/**
 * 接口 [分账方案](https://mcex-dev1.microconnect.cc/product/doc.html#/-product-v3-api-docs/dro%E4%BA%A7%E5%93%81%E8%A1%A8/getChannel)
 * @returns
 * */
export const fetchDivisionChannel = (params?) =>
  defHttp.get<AccountSchemeType>({
    url: Api.divisionChannel,
    params,
    headers: {
      'Content-Type': ContentTypeEnum.FORM_URLENCODED,
    },
  });

/**
 * 接口 [分账主导方](https://mcex-dev1.microconnect.cc/product/doc.html#/-product-v3-api-docs/dro%E4%BA%A7%E5%93%81%E8%A1%A8/getChannel)
 * @returns
 * */
export const fetchDivisionScheme = (params?) =>
  defHttp.get<AccountSchemeType>({
    url: Api.divisionScheme,
    params,
    headers: {
      'Content-Type': ContentTypeEnum.FORM_URLENCODED,
    },
  });

/**
 * 接口 [获取角色列表](https://mtex-dev1.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E7%99%BB%E9%99%86%E8%B4%A6%E5%8F%B7/getAvailableRoles)
 * @returns
 * */
export const fetchRoleList = (params?) =>
  defHttp.get<RoleInfoItem[]>({
    url: Api.roleList,
    params,
    headers: {
      'Content-Type': ContentTypeEnum.FORM_URLENCODED,
    },
  });

/**
 * 接口 [获取角色对应菜单](https://mtex-dev1.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E8%8F%9C%E5%8D%95/getMenuByRoleName)
 * @returns
 * */
export const fetchRoleMenu = (params?) =>
  defHttp.get<MenuItem[]>({
    url: Api.roleMenu,
    params,
    headers: {
      'Content-Type': ContentTypeEnum.FORM_URLENCODED,
    },
  });
/**
 * 接口 [获取会员可用菜单]
 */
export const fetchMemberMenu = (params?) =>
  defHttp.get<MenuItem[]>({
    url: Api.memberMenu,
    params,
    headers: {
      'Content-Type': ContentTypeEnum.FORM_URLENCODED,
    },
  });

/**
 * 接口 [批量查询成交价](https://mtex-dev1.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E8%8F%9C%E5%8D%95/getMenuByRoleName)
 * @returns
 * */
export const batchPrice = (params: string[]) =>
  defHttp.post<Record<string, DealPriceType>>(
    {
      url: Api.batchPrice,
      params,
    },
    {
      errorMessageMode: 'none',
    },
  );
/**
 * 接口 [产品搜索-etp](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E4%BA%A7%E5%93%81%E8%A1%A8/searchEtp)
 * @returns
 * */
export const searchProductEtpApi = (params: TransactionParams) =>
  defHttp.post<SearchEtpResultModel>({
    url: Api.etpList,
    params,
  });

/**
 * etp详情
 * @param {object} params 入参
 * @param {string} params.productCode 产品编码
 * @returns
 */
export const etpInfoApi = (params: GetProductDetailParams) =>
  defHttp.get<EtpDetailType>({
    url: Api.etpDetail,
    params,
  });

/**
 * [etp每日现金流](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E4%BA%A7%E5%93%81%E8%A1%A8/etpAcfInfo)
 * @param {object} params 入参
 * @param {string} params.productCode 产品编码
 * @returns
 * */
export const etpCashFlowApi = (params: GetProductDetailParams) =>
  defHttp.get<CashFlowResultType>({
    url: Api.etpCashFlow,
    params,
  });
/**
 * 接口 [etp行情](https://exmt-dev1.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E4%BA%A7%E5%93%81%E8%A1%A8/market)
 * @param {object} params 入参
 * @param {string} params.productCode 产品编码
 * @returns
 * */
export const etpInfoMarketApi = (params: GetProductDetailParams) =>
  defHttp.get<MarketType>({
    url: Api.etpMarket,
    params,
  });

/**
 * 接口 [etp历史行情](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E4%BA%A7%E5%93%81%E8%A1%A8/marketHis)
 */
export const etpHistoryMarketApi = (params: GetProductDetailParams) =>
  defHttp.get<MarketType[]>({
    url: Api.etpHistoryMarket,
    params,
  });

/**
 * 接口 [市场参考收益率](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E4%BA%A7%E5%93%81%E8%A1%A8/referList)
 */
export const etpReferListApi = (params: GetProductDetailParams) =>
  defHttp.get<ReferListType[]>({
    url: Api.etpReferList,
    params,
  });

/**
 * 接口 [etp汇总](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E4%BA%A7%E5%93%81%E8%A1%A8/summary)
 * @param {object} params 入参
 * @param {string} params.etpCode 产品编码
 * @param {number} params.type 类型：1全部，2top 5
 * @param {string} params.provinceCode 省份编码
 * @param {string} params.industryCode 行业编码
 * @returns
 * */
export const etpSummaryApi = (params: EtpSummaryParams) =>
  defHttp.post<EtpSummaryType>({
    url: Api.etpSummary,
    params,
  });

/**
 * [历史交易记录](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E4%BA%A7%E5%93%81%E8%A1%A8/tradeHis)
 */
export const etpHistoryTransactionApi = (params: GetHistoryTransactionParams) =>
  defHttp.get<any[]>({
    url: Api.etpHistoryTransaction,
    params,
  });

/**
 * [今日行情](https://mtex-dev2.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E4%BA%A7%E5%93%81%E8%A1%A8/matchHis)
 */
export const etpTodayMarketApi = (params: GetHistoryTransactionParams) =>
  defHttp.get<any[]>({
    url: Api.etpTodayMarket,
    params,
  });

/**
 * [查询账户对应产品持仓](https://mtex-dev2.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E6%89%98%E7%AE%A1%E7%99%BB%E8%AE%B0%E5%86%8C%E6%8C%81%E4%BB%93%E6%98%8E%E7%BB%86/findOne)
 */
export const fetchAccountProductHold = (params: HoldingRequestType) =>
  defHttp.post<HoldingResultType>({
    url: Api.accountProductHold,
    params,
  });

/**
 * [查询交易时间](https://mtex-dev2.microconnect.cc/trade/doc.html#/-trade-v3-api-docs/AO-IO%E7%94%B3%E8%B4%AD%E6%8E%A5%E5%8F%A3/getTradeDay)
 * @param {object} params 入参
 * @param {string} params.productCode 产品编码
 * @returns
 */
export const fetchTransactionTime = () =>
  defHttp.get<TransactionTimeType>({
    url: Api.queryTradeTime,
  });

/**
 * [仓位变动明细](https://mtex-dev2.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E6%89%98%E7%AE%A1%E7%99%BB%E8%AE%B0%E5%86%8C%E6%8C%81%E4%BB%93%E6%98%8E%E7%BB%86/flowList_1)
 */
export const fetchPositionChangeDetail = (params: PositionChangeDetailRequestType) =>
  defHttp.post<PositionChangeDetailResultType>({
    url: Api.positionChangeDetail,
    params,
  });

/**
 * [查询是否存在申购条款](https://mtex-dev2.microconnect.cc/trade/doc.html#/-trade-v3-api-docs/%E7%94%B3%E8%B4%AD%E6%9D%A1%E6%AC%BE/existSubscriptionTerms)
 */
export const fetchPurchaseClause = (params: { productCode: string }) =>
  defHttp.get<boolean>({
    url: Api.isExistPurchaseClause,
    params,
  });

/**
 * [下载申购条款](https://mtex-dev2.microconnect.cc/trade/doc.html#/-trade-v3-api-docs/%E7%94%B3%E8%B4%AD%E6%9D%A1%E6%AC%BE/downSubscriptionTerms)
 */
export const downloadPurchaseClause = (params: { productCode: string }) =>
  defHttp.get<string>(
    {
      url: Api.downloadPurchaseClause,
      responseType: 'blob',
      params,
    },
    {
      isTransformResponse: false,
    },
  );

/**
 * [充值提现流水](https://mtex-dev2.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E8%B5%84%E9%87%91%E8%B4%A6%E6%88%B7/flowList)
 */
export const fetchFundFlowsList = (params: FundFlowsRequestType) =>
  defHttp.post<FundFlowsResultType>({
    url: Api.fundFlowsList,
    params,
  });

/**
 * [查询月结单](https://mtex-dev2.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E4%BA%A4%E6%98%93%E8%B4%A6%E6%88%B7/report)
 */
export const fetchMonthlyStatement = (params: MonthlyStatementRequestType) =>
  defHttp.post<MonthlyStatementResultType>({
    url: Api.monthlyStatement,
    params,
  });

/**
 * [下载月结单](https://mtex-dev2.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E4%BA%A4%E6%98%93%E8%B4%A6%E6%88%B7/downloadSettlementReport)
 */
export const downloadMonthlyStatement = (params: {
  tradingAccountCode: string;
  cycle: string;
  reportType: SettlementTypeEnum;
}) =>
  defHttp.post(
    {
      url: Api.downloadMonthlyStatement,
      responseType: 'blob',
      data: params,
      params,
    },
    {
      isTransformResponse: false,
      isReturnNativeResponse: true,
    },
  );

/**
 * [查询角色列表](https://exmt-dev1.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E8%A7%92%E8%89%B2/searchRoles)
 */
export const fetchRoleListApi = (params: RoleInfoParams) =>
  defHttp.get<RoleListResultModel>({
    url: Api.roleSearch,
    params,
  });
/**
 * [查询角色详情](https://exmt-dev1.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E8%A7%92%E8%89%B2/getRoleDetail)
 */
export const fetchRoleDetailApi = (params: { roleId: string }) =>
  defHttp.get<RoleInfoItem>({
    url: Api.roleDetail,
    params,
  });
/**
 * [创建角色](https://exmt-dev1.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E8%A7%92%E8%89%B2/createRole)
 */
export const createRoleApi = (params: CreateRoleItem) =>
  defHttp.post<Boolean>({
    url: Api.createRole,
    params,
  });
/**
 * [更新角色](https://exmt-dev1.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E8%A7%92%E8%89%B2/updateRole)
 * @param params
 * @returns
 * */
export const updateRoleApi = (params: CreateRoleItem) =>
  defHttp.post<Boolean>({
    url: Api.updateRole,
    params,
  });
/**
 * [删除角色](https://exmt-dev1.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E8%A7%92%E8%89%B2/deleteRole)
 * @param params
 * @returns
 * */
export const deleteRoleApi = (params: { roleId: string }) =>
  defHttp.post<Boolean>({
    url: Api.deleteRole,
    params,
    data: params,
  });

export const assetDetailList = (params) =>
  defHttp.post<DRORecordResultModel>({
    url: Api.assetDetailList,
    params,
  });

/**
 * [获取费率](https://exmt-dev1-api.microconnect.cc/trade/doc.html#/-trade-v3-api-docs/%E8%B4%B9%E7%8E%87/getFeeRate)
 */
export const fetchRate = (params: TradeFeeParams) =>
  defHttp.get<number>({
    url: Api.rateSearch,
    params,
  });

export const searchDroList = (params: SearchDroParams) =>
  defHttp.post<SearchDroResultModel>({
    url: Api.searchDroList,
    params,
  });

export const findProBaseInfo = (params: FindProBaseInfo) =>
  defHttp.get({
    url: Api.findProBaseInfo,
    params,
  });

export const getDroTradeRule = (params: FindProBaseInfo) =>
  defHttp.get({
    url: Api.getDroTradeRule,
    params,
  });

export const droOrderSearch = (params: DroOrderSearchParams) =>
  defHttp.post<DroOrderResultModel>({
    url: Api.droOrderSearch,
    params,
  });

export const downloadOrderTemPlate = () =>
  defHttp.post<{ code: number; data: string; msg: string }>({
    url: Api.excelOrderTemplateApi,
  });
/**
 * 接口 [下载费率规则](https://exmt-dev1-api.microconnect.cc/trade/doc.html#/-trade-v3-api-docs/%E8%B4%B9%E7%8E%87/getFeeRateFile)
 */
export const feeTareDownloadApi = () =>
  defHttp.get(
    {
      url: Api.rateDescription,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
    },
  );

export const droOrderSearchExcel = (params) => {
  return defHttp.get<DroOrderExcelResultModel>({
    url: Api.droOrderSearchExcel,
    params,
  });
};

export const droOrderSubmit = (params: DroOrderSubmitParams) =>
  defHttp.post<DroOrderSubmitResultModel>(
    {
      url: Api.droOrderSubmit,
      params,
      timeout: 1000 * 60,
    },
    {
      isTransformResponse: false,
    },
  );

export const getAvailableShares = (params: GetAvailableShares) =>
  defHttp.get({
    url: Api.getAvailableShares,
    params,
  });

export const droOrderBatchCancel = (params: { orderCodes: string[] }) =>
  defHttp.post<batchCancelResultModel>(
    {
      url: Api.batchCancel,
      params,
    },
    {
      isTransformResponse: false,
    },
  );
/**
 * 接口 [查询循环投资](https://exmt-dev1-api.microconnect.cc/trade/doc.html#/-trade-v3-api-docs/%E5%BE%AA%E7%8E%AF%E6%8A%95%E8%B5%84/queryLoopInvest)
 * 返回null表示用户没有持有该product，返回status=0表示持有该product但没开启循环投资
 */
export const queryLoopInvestApi = (params: QueryLoopInvestParams) =>
  defHttp.post<QueryLoopInvestRes>({
    url: Api.queryLoopInvest,
    params,
  });

/**
 * 接口 [开启循环投资](https://exmt-dev1-api.microconnect.cc/trade/doc.html#/-trade-v3-api-docs/%E5%BE%AA%E7%8E%AF%E6%8A%95%E8%B5%84/open)
 */
export const openLoopInvestApi = (params: QueryLoopInvestParams) =>
  defHttp.post<Boolean>({
    url: Api.loopInvestOpen,
    params,
  });

/**
 * 接口 [关闭循环投资](https://exmt-dev1-api.microconnect.cc/trade/doc.html#/-trade-v3-api-docs/%E5%BE%AA%E7%8E%AF%E6%8A%95%E8%B5%84/close)
 */
export const closeLoopInvestApi = (params: QueryLoopInvestParams) =>
  defHttp.post<Boolean>({
    url: Api.loopInvestClose,
    params,
  });

/**
 * 接口 [查询etp基本信息](https://exmt-dev1-api.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E4%BA%A7%E5%93%81%E8%A1%A8/findEtpBaseInfo)
 */
export const fetchEtpBaseInfo = (params: { productCode: string }) =>
  defHttp.get<EtpBaseInfo>({
    url: Api.etpBaseInfo,
    params,
  });

/**
 * 接口 [求应投金额和](https://exmt-dev1-api.microconnect.cc/trade/doc.html#/-trade-v3-api-docs/%E5%BE%AA%E7%8E%AF%E6%8A%95%E8%B5%84/investBalanceSum)
 */
export const fetchInvestBalanceSum = (params: { tradingAccountCode: string }) =>
  defHttp.post<number>({
    url: Api.investBalanceSum,
    params,
  });

// 导出dro列表
export const exportDroList = (params: SearchDroParams) =>
  defHttp.post(
    {
      url: Api.droListExport,
      params,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
      isReturnNativeResponse: true,
    },
  );
// 现金流导出
export const exportCashFlow = (params: { productCode: string[] }) =>
  defHttp.post(
    {
      url: Api.cashFlowExport,
      params,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
      isReturnNativeResponse: true,
    },
  );

// 批量下单校验文件导出
export const exportOrderCheck = (params: { batchId: string }) =>
  defHttp.post(
    {
      url: Api.batchOrderCheckExport,
      params,
      responseType: 'blob',
    },
    {
      isTransformResponse: false,
      isReturnNativeResponse: true,
    },
  );

// dro 收益记录导出
export const exportDroRecord = (params) =>
  defHttp.post({
    url: Api.droRecordExport,
    params,
  });

/**
 * [查询专业投资人列表](https://exmt-dev1-api.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E4%B8%93%E4%B8%9A%E6%8A%95%E8%B5%84%E4%BA%BA/search)
 */
export const fetchProfessionalInvestorList = (params: ProfessionalInvestorParams) =>
  defHttp.post<ProfessionalInvestorResultModel>({
    url: Api.professionalList,
    params,
  });

/**
 * [查询专业投资人详情](https://exmt-dev1-api.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E4%B8%93%E4%B8%9A%E6%8A%95%E8%B5%84%E4%BA%BA/getDetail)
 */
export const fetchProfessionalInvestorDetail = (params: { id: string }) =>
  defHttp.get<ProfessionalInvestorItem>({
    url: Api.professionalDetail,
    params,
  });
/**
 * [新增修改专业投资人](https://exmt-dev1-api.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E4%B8%93%E4%B8%9A%E6%8A%95%E8%B5%84%E4%BA%BA/submit_1)
 */
export const submitProfessionalInvestor = (params: ProfessionalInvestorSubmitItem) =>
  defHttp.post<ProfessionalInvestorSubmitResult>({
    url: Api.professionalSubmit,
    params,
  });

/**
 * [获取声明文本](https://exmt-dev1-api.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E5%A3%B0%E6%98%8E/getStatementContent)
 */
export const fetchProfessionalTypeText = (params: ProfessionalTypeTextParams) =>
  defHttp.get<{ content: string }>({
    url: Api.professionalTypeText,
    params,
  });

export const exportCountApi = (params: IBusiness) =>
  defHttp.get({
    url: Api.exportCount,
    params,
  });

export const exportRecordApi = (params: ExportRecordParams) =>
  defHttp.post<ExportRecordResultModel>({
    url: Api.exportRecordApi,
    params,
  });

export const droBatchOrder = (params: DroBatchOrderParams) =>
  defHttp.post<DroBatchOrderResultModel>({
    url: Api.droBatchOrder,
    params,
  });
/**
 * [查询产品文件列表](https://exmt-dev1.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/dro%E4%BA%A7%E5%93%81%E8%A1%A8/getFileList)
 */
export const fetchProductFileList = (params: { productCode: string }) =>
  defHttp.get<FileItem[]>({
    url: Api.productFileList,
    params,
  });
/**
 * 资金流水导出
 */
export const exportFundFlow = (params: ExportFundFlowParams) =>
  defHttp.post({
    url: Api.fundFlowsExport,
    params,
  });

/**
 * [查询产品扩展信息](https://exmt-dev1.microconnect.cc/analysis/doc.html#/-analysis-v3-api-docs/%E6%96%87%E4%BB%B6%E6%8B%93%E5%B1%95%E4%BF%A1%E6%81%AF/getExtendInfoList)
 */
export const fetchProductExtendInfo = (params: { productCode: string }) =>
  defHttp.get<ExtendInfoItem[]>({
    url: Api.productExtendInfo,
    params,
  });
/**
 * 委托So订单导出
 */
export const exportSoOrder = (params: ExportSoOrderParams) =>
  defHttp.post({
    url: Api.soOrderExport,
    params,
  });
/**
 * [委托Io订单导出](https://exmt-dev1.microconnect.cc/trade/doc.html#/-trade-v3-api-docs/AO-IO%E7%94%B3%E8%B4%AD%E6%8E%A5%E5%8F%A3/selectPageExport_4)
 */
export const exportIoOrder = (params: ExportIoOrderParams) =>
  defHttp.post({
    url: Api.ioOrderExport,
    params,
  });

/**
 * [资金类型字典](https://exmt-dev1.microconnect.cc/member/doc.html#/-member-v3-api-docs/%E8%B5%84%E9%87%91%E8%B4%A6%E6%88%B7/fundTypeDict)
 */
export const fetchFundType = () =>
  defHttp.get<FundTypeItem[]>({
    url: Api.fundTypeDict,
  });

export const fetchCurrencyNumber = (params: { productCodes: string[] }) => {
  return defHttp.post<number>({
    url: Api.currencyCount,
    params,
  });
};
